<template>
	<div class="p-x-20 p-y-16 bg-white">
		<div class="f-regular f-14 f-c-midgrey">
			Paket Deposit {{ info.nama_konsumen }}
		</div>
		<div class="f-regular f-14">
			<span class="f-c-midgrey">Pemakaian terakhir </span>
			<span class="f-c-black">
				{{ info.tanggal_pemakaian_terakhir !== '' ? info.tanggal_pemakaian_terakhir : '-' }}
			</span>
		</div>
		<div class="f-regular f-14">
			<span class="f-c-midgrey">Top Up terakhir </span>
			<span class="f-c-black">
				{{ info.tanggal_topup_terakhir !== '' ? info.tanggal_topup_terakhir : '-' }}
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOCardPaketDepositCustomerInfo",
	props: {
		info: Object,
	}
}
</script>